export default __webpack_public_path__ + "assets/images/others/4c7bd86cd20b82c0436861b3287c5a60.png";